module.exports = __webpack_public_path__ + "img/01-illu-kafu0513.a2c9427d.png";